import request from 'catalog/utils/axios'

export const getSkus = async productId => {
  const response = await request
    .get(`/product/${productId}/skus`)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })
  return response
}
